<template>
    <div class="report">

        <div class="report-title">
            <h5>{{title}}</h5>
            <p>{{subTitle}}</p>
        </div>
        <!-- <div class="report-title">
            <h5>代保管查询</h5>
            <p>您可通过手机号码查询代保管记录</p>
        </div> -->
        <div class="report-input">
          <!-- @blur="getIsPhone" @blur="getIsqrCode"-->
            <input type="text"  v-model = "phone" id="phone" placeholder="请输入手机号">
            <div class="report_yzm">
                <input type="text" v-model="qrcode"  placeholder="请输入验证码">
                <button @click="buttonStatus" :disabled ='disableds' ref="buttonStatus">{{btncontent}}</button>
            </div>
        </div>
        <div class="report-btn">
            <button class="report_submit" :disabled ='disableds2'  @click="submit">立即查询</button>
        </div>
    </div>
</template>
<script>
import validate from '../../lib/js/validata'
export default {
  name: 'findReport',
  data () {
    return {
      phone: '',
      qrcode: '',
      btncontent:'获取验证码',
      disableds: false,
      disableds2: false,
      find_id: null,
      title:'报告查询',
      subTitle :'您可通过手机号码查询检测报告',
      submitEvent_type: false
    }
  },
  created () {
    this.getId()
  },
  methods: {
    getId () {
      this.find_id = this.$route.params.id;

      if( this.find_id == 'find_report' ){
        this.submitEvent_type = false;
        this.title = '报告查询'
        this.subTitle = '您可通过手机号码查询检测报告'
      }else if ( this.find_id == 'find_report_instand' ){
        this.submitEvent_type = true;
        this.title = '代保管查询'
        this.subTitle = '您可通过手机号码查询代保管记录'
      }
      // console.log(this.submitEvent_type);
    },
    // getIsPhone () {
    //   let phones = validate.isPhone(this.phone);
    //   // console.log(phones)
    // },
    // getIsqrCode () {
    //   let qrcodes = validate.isqrCode(this.qrcode)
    //   // console.log(qrcodes)
    // },
    // 获取验证码
    buttonStatus () {
      let phonenumber = validate.isPhone(this.phone);
      if(!phonenumber.phoneStatus){
        // console.log('请输入合法手机号');
        return
      }

      // 0820
       this.$createDialog({
          type: 'alert',
          content: '验证码已发送，请注意查收',
       }).show()

      let countdown=60; 
      this.setTime(countdown)
      this.$http.api.phoneInfo({
        phone: this.phone
      }).then( result => {
        // console.log(result)
      })
    },
    setTime (countdown) {
      var _this = this
      if (countdown == 0) {
        this.disableds = false
        this.btncontent = "获取验证码"
        countdown = 60
        return;
      } else {
        this.disableds = true
        this.btncontent = "重新发送(" + countdown + ")"
        countdown--
      }
      setTimeout(function() {
        _this.setTime(countdown)
      },1000)
    },
    submit(){
      let _this = this
      if(!validate.isPhone(this.phone).phoneStatus) {
        return
      }else if(!validate.isqrCode(this.qrcode).qrCodeStatus){
        return
      }

      if(!this.submitEvent_type){
        // 查询指定用户的报告
        _this.$http.api.findOnlyreport({
          code: _this.qrcode,
          phone: _this.phone
        }).then (result => {
          // this.$router.push({name: 'payGoods', params: {'commodity_id': this.commodity_id}})
           console.log('result:',result)
          if(result.length == 0){
            const toast = this.$createToast({
                txt: '您没有可查询的报告',
                type: 'txt'
            }).show()
             this.disableds2 = true

          }else {
             console.log('result:',result)

            this.$router.push({ name: 'reportList', params: { 'report_id': _this.phone, 'report_type': '1' }})
            // this.$router.push({ name: 'reportList', params: { 'result': result}})
          // console.log(result.file)
          // window.location.href = result.file
          // console.log(result)
          }
        })
      }else {
        // 查询代保管报告
        _this.$http.api.findCustody({
          code: _this.qrcode,
          phone: _this.phone
        }).then( result => {

          if(result.rows.length == 0){
            const toast = this.$createToast({
                txt: '您没有可查询的订单',
                type: 'txt'
            }).show()

          }else {
            this.$router.push({name:'findReportin',params:{'report_id': _this.phone}})
          }
          // this.$router.push({name:'reportDetail',params:{'report_id': result.report_id, 'report_type': '1'}})
          // window.location.href = result.file
          // console.log(result)
        })

      }
    }
  }
}
</script>
<style>
  .cube-dialog-btn_highlight{
    color: #61B0E3;
  }
</style>
<style lang="less" scoped>
.report{
  background: #61B0E3;
  height: 100vh;
  padding-top: 50px;
  box-sizing: border-box;
  .report-title{
    width: 100%;
    text-align: center;
    margin-bottom: 58px;
    h5{
    //   width:143px;
    //   height:36px;
      font-size:18px;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(255,255,255,1);
    }
    p{
    //   width:419px;
    //   height:30px;
      font-size:15px;
      font-family:MicrosoftYaHeiLight;
      font-weight:300;
      color: #D5F1F4;
    //   color:rgba(255,255,255,1);
    }
  }
  .report-input{
    //   width: 240px;
    //   height: 100px;
      margin: 0 auto;
      text-align: center;
    //   border: 1px solid #b3daf2;
      border-radius: 5px;
      padding: 0 35px;
      margin-bottom: 149px;
      box-sizing: border-box;
      overflow: hidden;
      input{
        width: 100%;
        height: 50px;
        font-size: 12px;
        background: 0 0;
        border-bottom: 1px solid #b3daf2;
        color: #fff;
        padding-left: 10px;
      }
      ::-webkit-input-placeholder{color:rgba(255,255,255,.8)}
      ::-moz-placeholder{color:rgba(255,255,255,.8)}
      ::-ms-input-placeholder{color:rgba(255,255,255,.8)}
    //   input:last-child{
    //     border: none;
    //   }
      .report_yzm{
          width: 100%;
          height: 50px;
          border-bottom: 1px solid #b3daf2;
          text-align: center;
          overflow: hidden;
          input{
            width: 65%;
            float: left;
            border: none;
          }
          button{
              width: 30%;
              height: 30px;
              font-size: 10px;
              margin-top: 10px;
              border: none;
              border-radius: 18px;
              background: #fff;
              line-height: 24px;
              outline: none;
              color: #61B0E3;
              float: right;
          }
      }
    }
    .report-btn{
      width: 100%;
      text-align: center;
      // background: #fff;
      .report_submit{
        width:90px;
        height:30px;
        background:#fff;
        border-radius:8px;
        line-height: 30px;
        outline: none;
        border: none;
        color: rgba(96,176,227,1);
        font-size: 13px;
        padding: 0 10px;
      }
    }

}

</style>


